import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule, provideDefaultConfig } from '@spartacus/core';
import { GGFirmwareVerificationComponent } from './gg-firmware-verification.component';
import { DIALOG_TYPE, FormErrorsModule, IconModule } from '@spartacus/storefront';
import { ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha-2';
import { FirmwareImageDialogComponent } from './firmware-image-dialog/firmware-image-dialog.component';

@NgModule({
  declarations: [
    GGFirmwareVerificationComponent,
    FirmwareImageDialogComponent,
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        GGFirmwareVerificationComponent: {
          component: GGFirmwareVerificationComponent,
        },
      },
    } as CmsConfig),
    FormErrorsModule,
    I18nModule,
    ReactiveFormsModule,
    IconModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: '6Lcgb6wrAAAAAP0pXRwQcqSWBxAtTZ7NLs8Rysj8' } as RecaptchaSettings,
    },
    provideDefaultConfig({
      launch: {
        FIRMWARE_IMAGE_OPEN: {
          inlineRoot: true,
          component: FirmwareImageDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
})
export class GgFirmwareVerificationModule {}
